import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import PublicBooking from "@/pages/PublicBooking";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import SuperAdminDashboard from "@/pages/SuperAdminDashboard";
import LandingPage from "@/pages/LandingPage";
import LegalPending from "@/pages/LegalPending";
import PasswordRecovery from "@/pages/PasswordRecovery";
import { Scissors } from "lucide-react";

function Protected({ children, role }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Scissors className="w-8 h-8 text-[#D4AF37] animate-pulse" />
      </div>
    );
  if (!user) return <Navigate to={role === "super_admin" ? "/saas/login" : "/admin/login"} replace />;
  if (user.role !== role) return <Navigate to={user.role === "super_admin" ? "/saas" : "/admin"} replace />;
  return children;
}

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/privacidade" element={<LegalPending title="Privacidade" />} />
      <Route path="/termos-de-uso" element={<LegalPending title="Termos de uso" />} />
      <Route path="/agendar/:slug" element={<PublicBooking />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<Protected role="barbershop_admin"><AdminDashboard /></Protected>} />
      <Route path="/saas/login" element={<AdminLogin />} />
      <Route path="/saas/esqueci-senha" element={<PasswordRecovery mode="request" />} />
      <Route path="/saas/redefinir-senha" element={<PasswordRecovery mode="confirm" />} />
      <Route path="/saas" element={<Protected role="super_admin"><SuperAdminDashboard /></Protected>} />
      <Route path="/saas/conta" element={<Protected role="super_admin"><SuperAdminDashboard /></Protected>} />
      <Route path="/saas/barbearias" element={<Protected role="super_admin"><SuperAdminDashboard /></Protected>} />
      <Route path="/saas/financeiro" element={<Protected role="super_admin"><SuperAdminDashboard /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-center" theme="dark" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
